import { render, staticRenderFns } from "./AuthorAgent.vue?vue&type=template&id=4e65786c&scoped=true&"
import script from "./AuthorAgent.vue?vue&type=script&lang=ts&"
export * from "./AuthorAgent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e65786c",
  null
  
)

export default component.exports